export default {
  name: "UploadButton",
  functional: true,
  props: {
    btnStyle: {
      type: String,
      default: ""
    },
    button: {
      type: Object,
      default() {
        return {};
      }
    },
    owner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h, _vm) {
    let props = _vm.props;
    // return (
    //   <el-upload
    //     class="ds-button-update"
    //     style={_vm.data.style}
    //     disabled={props.button.disabled}
    //     headers={props.owner.getHeaders()}
    //     multiple={props.button.multiple}
    //     accept={props.owner.getFileAccept(props.button)}
    //     data={props.owner.getUploadData(props.button)}
    //     show-file-list={false}
    //     action={props.owner.uploadUrl(props.button)}
    //     on-progress={props.owner.handleProgress}
    //     on-change={props.owner.handleChange}
    //     on-success={() => {
    //       props.owner.handleAvatarSuccess(props.button);
    //     }}
    //     before-upload={props.owner.beforeAvatarUpload(props.button)}
    //   >

    //   </el-upload>
    // );
    return h(
      "el-upload",
      {
        class: "ds-button-update",
        style: _vm.data.style,
        props: {
          disabled: props.button.disabled,
          headers: props.owner.getHeaders(),
          multiple: props.button.multiple,
          accept: props.owner.getFileAccept(props.button),
          data: props.owner.getUploadData(props.button),
          showFileList: false,
          action: props.owner.uploadUrl(props.button),
          onProgress: props.owner.handleProgress,
          onChange: props.owner.handleChange,
          onSuccess: props.owner.handleAvatarSuccess(props.button),
          beforeUpload: props.owner.beforeAvatarUpload(props.button)
        }
      },
      [renderUploadButton(h, _vm)]
    );
  }
};

function renderUploadButton(h, _vm) {
  let props = _vm.props;
  return (
    <DsfButton
      icon={props.owner.getIcon(props.button)}
      title={props.button.title}
      disabled={props.button.disabled}
      size={props.owner.size}
      type={props.button.type}
      btn-style={props.btnStyle || props.button.btnStyle}
      icon-position={props.button.iconPosition}
      loading={props.button.loading}
      on-click={($event) => {
        props.owner.uploadClickBefore(props.button, $event);
        $event.stopPropagation();
      }}
    >
      {props.button.text}
    </DsfButton>
  );
}
